import { render, staticRenderFns } from "./AutoAssignAccessControl.vue?vue&type=template&id=36a4ff3b&lang=pug"
import script from "./AutoAssignAccessControl.vue?vue&type=script&lang=js"
export * from "./AutoAssignAccessControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports